import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../misc/directives/error-message.directive';
import { MiscModule } from '../../misc/misc.module';
import { RegisterPageRoutingModule } from './register-routing.module';
import { RegisterPageComponent } from './register.page';

@NgModule({
  declarations: [RegisterPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RegisterPageRoutingModule,
    MaskitoDirective,
    MiscModule,
    ErrorMessageDirective
  ]
})
export class RegisterPageModule {}
